import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const CompanyNoticeDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsCompanyNoticeDetails" */ 'modules/activityDetails/CompanyNoticeDetails/pages/CompanyNoticeDetails'
    )
)

const CompanyNoticeDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route
        exact
        path={`${routes.root}/:companyNoticeId/:activityId`}
        component={CompanyNoticeDetails}
      />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default CompanyNoticeDetailsRouting
